/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { JsmKbAiFirstCreateRuntimeProps } from './JsmKbAiFirstCreate.entrypoint.types.tsx';

type JsmKbAiFirstCreateEntryPointComponent = EntryPointComponent<
	{},
	{},
	JsmKbAiFirstCreateRuntimeProps
>;

export const jsmKbAiFirstCreateEntryPoint: EntryPoint<
	JsmKbAiFirstCreateEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<JsmKbAiFirstCreateEntryPointComponent>(
		/* webpackChunkName: "async-jsm-kb-ai-first-create-entrypoint" */ './JsmKbAiFirstCreateComponent.tsx',
	),
	getPreloadProps: (_entryPointRouteParams: EntryPointRouteParams) => {
		return {
			entryPoints: {},
		};
	},
});
